import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EqualtecModalPresavisioneComponent } from '../equaltec/equaltec-modal-presavisione/equaltec-modal-presavisione.component';

@Injectable({
  providedIn: 'root'
})
export class PresaVisioneModalService {

  constructor(private modalService: NgbModal) { }

  open(idDocument: number, idAllegato: string, download: boolean, fileName: string): void {
    const modalRef = this.modalService.open(EqualtecModalPresavisioneComponent, {
      windowClass: 'equaltec-presavisione-modal',
      backdrop: 'static'
    });

    modalRef.componentInstance.idDocument = idDocument != null ? idDocument.toString() : '';
    modalRef.componentInstance.idAllegato = idAllegato;
    modalRef.componentInstance.download = download;
    modalRef.componentInstance.fileName = fileName;
  }
}
